var React = require('react');

function IconPenWithPaperO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M786 280.8L611.4 105.7c-11.4-11.4-29.8-11.4-41.2 0-12.7 12.8-465.7 466.9-465.7 466.9-5.5 5.5-8.5 12.9-8.5 20.6v175.1c0 16.1 13 29.2 29.1 29.2h174.6c7.7 0 15.1-3.1 20.6-8.6l465.7-467c11.4-11.2 11.4-29.7 0-41.1zM287.7 739.2H154.2V605.4c40.1-40.2 213.4-213.9 334.7-335.6l133.5 133.8-334.7 335.6zm375.9-376.9L530.1 228.5c25.3-25.3 46.3-46.4 60.7-60.9l133.5 133.8-60.7 60.9zM122.7 876.1h596c14.3 0 25.9 11.4 25.9 25.6 0 14.1-11.6 25.6-25.9 25.6h-596c-14.3 0-25.9-11.4-25.9-25.6-.1-14.2 11.5-25.6 25.9-25.6zM822.3 876.1H900c14.3 0 25.9 11.4 25.9 25.6 0 14.1-11.6 25.6-25.9 25.6h-77.7c-14.3 0-25.9-11.4-25.9-25.6 0-14.2 11.6-25.6 25.9-25.6z"}));
}

IconPenWithPaperO.displayName = "IconPenWithPaperO";

IconPenWithPaperO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPenWithPaperO;

IconPenWithPaperO.default = IconPenWithPaperO;
